import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntTranslate, translate } from "src/app/support/translate";

export enum ErrorCodes {
  ERR_001 = "ERR_001",
  ERR_002 = "ERR_002",
  ERR_003 = "ERR_003",
  ERR_004 = "ERR_004",
  ERR_005 = "ERR_005",
  ERR_006 = "ERR_006",
  ERR_007 = "ERR_007",
  ERR_008 = "ERR_008",
  ERR_009 = "ERR_009",
  ERR_010 = "ERR_010",
  ERR_011 = "ERR_011",
  ERR_012 = "ERR_012",
  ERR_013 = "ERR_013",
  ERR_014 = "ERR_014",
  ERR_015 = "ERR_015",
  ERR_016 = "ERR_016",
  ERR_017 = "ERR_017"
}

export function buildErrorCodesMap(): Record<ErrorCodes, string> {
  return {
    ERR_001: translate(marker("Non hai nessun account presso questo tenant")),
    ERR_002: sntTranslate(marker("Box non disponibile")),
    ERR_003: sntTranslate(
      marker("Impossibile caricare i dati dell'utente corrente")
    ),
    ERR_004: sntTranslate(marker("Percorso non autorizzato")),
    ERR_005: sntTranslate(
      marker("Impossibile caricare i profili fiscali (billing)")
    ),
    ERR_006: sntTranslate(
      marker("Impossibile caricare la configurazione (billing)")
    ),
    ERR_007: sntTranslate(marker("Utente disabilitato")),
    ERR_008: sntTranslate(marker("File lingua non disponibili")),
    ERR_009: sntTranslate(
      marker("Questo tenant è sospeso per ragioni amministrative")
    ),
    ERR_010: sntTranslate(
      marker("Tutti i tuoi tenant sono sospesi per ragioni amministrative")
    ),
    ERR_011: sntTranslate(marker("Nessun membro disponibile per l'admin")),
    ERR_012: sntTranslate(
      marker("Nessun membro con scope PLATFORM disponibile")
    ),
    ERR_013: sntTranslate(marker("Nessun membro disponibile")),
    ERR_014: sntTranslate(marker("Nessun membro/tenant disponibile")),
    ERR_015: sntTranslate(marker("Connessione SSE non disponibile")),
    ERR_016: sntTranslate(marker("Nessun membro per questo tenant")),
    ERR_017: sntTranslate(marker("Servizio attualmente interrotto"))
  };
}
